import React from 'react';
import { useIntl } from 'react-intl';

import { renderWithBreaks } from '@utils/translations';

const PrivacyPolicyTab = () => {
  const intl = useIntl();

  return (
    <div>
      <h3>{intl.formatMessage({ id: 'Introduction'})}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy introduction' }))}
      <h3>{intl.formatMessage({ id: '1. Who operates Uniplaces and how do I contact them?'})}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 1' }))}
      <h3>{intl.formatMessage({ id: '2. How does Uniplaces use my personal data as a tenant?'})}</h3>
      <p>{intl.formatMessage({ id: 'In summary, we use personal data relating to tenants to:' })}</p>
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 2 list' }), 'li')}</ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 2' }))}
      <h3>{intl.formatMessage({ id: '3. How does Uniplaces use my personal data as a landlord?'})}</h3>
      <p>{intl.formatMessage({ id: 'In summary we use personal data relating to landlords:' })}</p>
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 3 list' }), 'li')}</ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 3' }))}
      <h3>{intl.formatMessage({ id: '4. How does Uniplaces use my personal data as an affiliate?' })}</h3>
      <p>{intl.formatMessage({ id: 'We use personal data relating to affiliates:' })}</p>
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 4 list' }), 'li')}</ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 4' }))}
      <h3>{intl.formatMessage({ id: '5. How does Uniplaces use personal data for marketing?' })}</h3>
      <p>
        {intl.formatMessage({
          id: 'In summary, regardless of whether you are a landlord, tenant or affiliate, we use personal data:'
        })}
      </p>
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 5 list' }), 'li')}</ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 5' }))}
      <h3>{intl.formatMessage({ id: '6. How does Uniplaces use my personal data as a supplier?' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 6' }))}
      <h3>{intl.formatMessage({ id: '7. How does Uniplaces use my personal data as a job applicant?' })}</h3>
      <p>{intl.formatMessage({ id: 'If you apply for a job at Uniplaces, we may use your personal information:' })}</p>
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 7 list' }), 'li')}</ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 7' }))}
      <h3>{intl.formatMessage({id: '8. How does Uniplaces otherwise use personal data in running its business?' })}</h3>
      <p>
        {intl.formatMessage({
          id: 'In summary, regardless of whether you are a landlord, tenant or affiliate, we use personal data:'
        })}
      </p>
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 8 list' }), 'li')}</ul>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 8' }))}
      <h3>{intl.formatMessage({ id: '10. Who does Uniplaces share personal data with?' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 10' }))}
      <h3>
        {intl.formatMessage({ id: '11. Does Uniplaces transfer personal data outside of the European Economic Area?' })}
      </h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 11' }))}
      <h3>
        {intl.formatMessage({
          id: '12. What are my rights in relation to Uniplaces processing my personal data and how do I exercise them?'
        })}
      </h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 12' }))}
      <ul>{renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 12 list' }), 'li')}</ul>
      <p>
        {intl.formatMessage({
          id: 'Please note that in order to protect your privacy, we may ask you to prove your identity before we take any steps in response to a request you have made.'
        })}
      </p>
      <h3>{intl.formatMessage({ id: '13. How and when will Uniplaces make changes to this guide?' })}</h3>
      {renderWithBreaks(intl.formatMessage({ id: 'Privacy Policy 13'}))}
    </div>
  );
}

export default PrivacyPolicyTab;
